function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 19"
}, props), React.createElement("path", {
  d: "M3.44.018A3.432 3.432 0 000 3.458V15.04a3.432 3.432 0 003.44 3.44h11.583a3.432 3.432 0 003.44-3.44V3.457a3.432 3.432 0 00-3.44-3.44H3.44zM26 1.725l-2.66.731c-1.155.319-2.529 1.13-2.53 2.532v8.52c0 1.403 1.177 2.159 2.53 2.532l2.66.733V1.725z",
  fill: "#fff"
})));